<div class="bookcontainer">
    <a href="https://drive.google.com/file/d/1Yhv_Tx98lFl75gbLv7TSdHyAjwzO4LQ_" style="text-decoration: none;">
        <mat-card class="book">
            <img mat-card-image src="../../../../../../../assets/images/editoria/aavv_pre-proceedings_title.png"
                alt="Pulsante pre-proceedings">
        </mat-card>
    </a>
    <div class="book-details-box">
        <div class="book-details">
            <p class="title">CIFRIS24 Preproceedings Draft</p>
            <p class="author">DE CIFRIS KOINE vol.5</p>
        </div>
    </div>
</div>